export const enClientPortalAssetPreview = {
    ratings: {
        locationQuality: 'Location quality',
        assetQuality: 'Asset quality',
        rentalSituation: 'Rental situation',
    },
}
